import { useEffect, useState } from "react";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { ReactNode } from "react";
import { POSTHOG_LIB_VERSION } from "../constants";
import { postHogConfig } from "../utils/postHogConfig";

export function PHProvider(
  { children }: { children: ReactNode }
) {
  const [hydrated, setHydrated] = useState(false);
  const { enabled, apiKey, host, replayEnabled } = postHogConfig;

  useEffect(() => {
    if (enabled) {
      posthog.init(apiKey, {
        api_host: host,
        defaults: POSTHOG_LIB_VERSION, // PostHog API version identifier
        loaded: (ph) => {
          if (replayEnabled) {
            ph.startSessionRecording();
          }
          if (import.meta.env.DEV) {
            console.log("[PostHog] Initialized", {
              apiKey,
              host,
              replayEnabled,
            });
          }
        },
        capture_pageview: false,
        capture_pageleave: false,
        disable_session_recording: !replayEnabled,
        mask_all_text: true,
        mask_all_element_attributes: true,
      });
    }
    setHydrated(true);
  }, [enabled, apiKey, host, replayEnabled]);

  if (!hydrated || !enabled) return <>{children}</>;
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
};
